module.exports = __webpack_public_path__ + "static/media/bg-login.fcbadd33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-login.jpg
// module id = 722
// module chunks = 0